export const GRANULARITIES = [
  { value: "year", label: "År" },
  { value: "month", label: "Måned" },
  { value: "week", label: "Uke" },
  { value: "day", label: "Dag" },
] as const;

export const MAX_REFERRAL_POINTS = 1500;

export function periodLabel(granularity: string) {
  return GRANULARITIES.find((g) => g.value === granularity)?.label ?? "Måned";
}

/** Weeks use Monday's date, including weeks crossing a calendar year. */
export function referralPeriods(from: string, to: string, granularity: string) {
  const cursor = new Date(`${from}T00:00:00Z`);
  const end = new Date(`${to}T00:00:00Z`);
  if (cursor > end) return [];
  if (granularity === "year") cursor.setUTCMonth(0, 1);
  else if (granularity === "month") cursor.setUTCDate(1);
  else if (granularity === "week") cursor.setUTCDate(cursor.getUTCDate() - (cursor.getUTCDay() + 6) % 7);
  const periods: string[] = [];
  while (Number.isFinite(cursor.getTime()) && cursor <= end && periods.length <= MAX_REFERRAL_POINTS) {
    periods.push(cursor.toISOString().slice(0, granularity === "year" ? 4 : granularity === "month" ? 7 : 10));
    if (granularity === "year") cursor.setUTCFullYear(cursor.getUTCFullYear() + 1);
    else if (granularity === "month") cursor.setUTCMonth(cursor.getUTCMonth() + 1);
    else cursor.setUTCDate(cursor.getUTCDate() + (granularity === "week" ? 7 : 1));
  }
  return periods;
}

export function effectiveGranularity(from: string, to: string, requested: string) {
  const order = ["day", "week", "month", "year"];
  const start = order.includes(requested) ? order.indexOf(requested) : order.indexOf("month");
  return order.slice(start).find((g) => referralPeriods(from, to, g).length <= MAX_REFERRAL_POINTS) ?? "year";
}
